import { useEffect, useMemo } from 'react'

import { useViews } from 'data/hooks/views'

type UseEmbedWidgetEmbeddedViewStateProps = {
    field: FieldDto
    fieldValue?: string | string[]
    onError: () => void
}

export function useEmbedWidgetEmbeddedViewState({
    field,
    fieldValue,
    onError,
}: UseEmbedWidgetEmbeddedViewStateProps) {
    const recordSid = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue

    const objectSid = field.link_target_object_id
    const { data: views = [] } = useViews()

    const detailView = views.find((v) => v.object_id === objectSid && v.type === 'detail')

    useEffect(() => {
        if (objectSid && views.length > 0 && !detailView) {
            onError()
        }
    }, [objectSid, views.length, detailView, onError])

    return useMemo(
        () => ({
            viewSid: detailView?._sid,
            recordSid,
        }),
        [detailView, recordSid]
    )
}
